import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=01eb6f2a&scoped=true&"
import script from "./authority.vue?vue&type=script&lang=js&"
export * from "./authority.vue?vue&type=script&lang=js&"
import style0 from "./authority.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./authority.vue?vue&type=style&index=1&id=01eb6f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eb6f2a",
  null
  
)

export default component.exports